import Vue from 'vue';
let vm = new Vue();
import axios from 'axios'
import qs from 'qs';

import Config from './config'
import Utils from './utils'
import User from './user'
import Router from '../router'

import md5 from 'js-md5';
import Moment from 'moment';

// export default {
const http = {
    httpPost:function(obj){
        let _datas,_heads;
        if(obj.type=='json'){
          _datas = Utils.isUndefined(obj.datas) ? null : obj.datas;
          _heads = {'Content-Type':'application/json','Accept': 'application/json'};
        }else{
          _datas = Utils.isUndefined(obj.datas) ? null : qs.stringify(obj.datas);
          _heads = {'Content-Type':'application/x-www-form-urlencoded','Accept': 'application/json'};
        }
        let _showLoad = Utils.isUndefined(obj.showLoad) ? false : obj.showLoad;
        let loadingInstance = null;
        if(_showLoad) {
            loadingInstance = vm.$loading({lock:true});
        }

        if(obj.url !== 'Member/login'){
            _heads.Authorization = User.getToken();
        }

        let _time = Moment().unix();

        let _secret = md5(Config.secret + _time.toString());

        _heads.secret = _secret;
        _heads.timestamp = _time;

        axios.defaults.timeout = 300000;
        let baseUrl;
        
        baseUrl = Config.apiUrl;
        // obj.type=='json'?baseUrl=Config.serviceUrl:baseUrl=Config.apiUrl;

        // console.log(_heads);
        axios({
            headers:_heads,
            method: 'post',
            url: obj.url.indexOf('http') >= 0 ? obj.url : baseUrl+obj.url,
            data:_datas,
            responseType:obj.download ? 'arraybuffer' : 'application/json',
        }).then(function(res){
            if(loadingInstance){
                vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    loadingInstance.close();
                });
            }
            if(obj.download){
                if (obj.success) {
                    obj.success(res.data);
                }
            }else {
                if (res.data.code === 0) {
                    if (obj.success) {
                        obj.success(res.data.result);
                    }
                } else {
                    if (res.data.code === 10005) {
                        vm.$message.error({message: '登录信息已失效，请重新登录', duration: 2000});
                        Utils.sessionClear();
                        Router.replace({path: '/'});
                    } else {
                        if (obj.fail) {
                            obj.fail(res.data);
                        } else {
                            vm.$message.error({message: res.data.msg, duration: 2000});
                        }
                    }
                }
            }
        }).catch(function (error) {
            console.log(error.response)
            if(obj.download){
                const decoder = new TextDecoder('utf-8');
                const jsonString = decoder.decode(error.response.data);
                let jsonObj = JSON.parse(jsonString);
                vm.$message.error({message: jsonObj.msg, duration: 2000});
            }else{
                console.log(error);
                vm.$message.error({message: error.response.data.msg, duration: 2000});
                if(loadingInstance){
                    vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                        loadingInstance.close();
                    });
                }
            }
        }).finally(rrr=>{
            if(loadingInstance){
                vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    loadingInstance.close();
                });
            }
        })
    },
    upLoad:function(file){
        let config = {
            //添加请求头
            headers: { "Content-Type": "multipart/form-data" },
            //添加上传进度监听事件
            onUploadProgress: e => {
                var completeProgress = ((e.loaded / e.total * 100) | 0) + "%";
                this.progress = completeProgress;
            }
        };

        let param = new FormData();
        param.append("imageFile", file);
        console.log(param.get("imageFile"));

        axios.post('http://miiheapi/user/up', param, config).then(
            function (response)
            { console.log(response); })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export default http;
